import { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { session } from '../../services/session';

class Redirect extends Component {
  constructor(props) {
    super(props);

    this.Session = session;
  }

  componentDidMount() {
    this.redirect();
  }

  redirect() {
    if (!this.Session.userId) {
      const originalPath = this.props.location.pathname;
      if (originalPath === '/v2') {
        this.props.history.push('/v2/login');
      } else {
        this.props.history.push({
          pathname: '/v2/login',
          search: `?redirect=${originalPath}`,
        });
      }
    } else {
      this.redirectLoggedInUser();
    }
  }

  redirectLoggedInUser() {
    const userRole = this.Session.userRole.replace(/s$/, '');
    const orgId = this.Session.orgId ? `${this.Session.orgId}/` : '';
    const orgPath = `${userRole}/${orgId}`;
    const pathName = this.props.location.pathname;

    let { path } = this.props;
    if (pathName.includes('admin')) {
      // Redirect v1 admin routes
      window.location.assign(pathName.replace('v2', '#'));
    } else if (path) {
      path = `/${orgPath}${path}`;
    } else {
      path = this.getDefaultPath(userRole, orgPath);
    }

    // TODO: temporary fix for product match
    if (path && path.includes('#')) {
      window.location = path;
    } else {
      this.props.history.push(path);
    }
  }

  getDefaultPath(userRole, orgPath) {
    let path;

    switch (userRole) {
      case 'publisher':
        if (session.publisher_type === 2 && this.props.isMobile) {
          path = `/v2/${orgPath}link-creation`;
        } else {
          path = `/v2/${orgPath}dashboard`;
        }
        break;
      case 'merchant':
        path = `/v2/${orgPath}desk`;
        break;
      case 'admin':
        path = '/v2/admin';
        break;
      case 'product_match':
        path = '/v2/admin/smartlinks/editor';
        break;
      default:
        path = `/v2/${orgPath}network`;
    }

    return path;
  }

  render() {
    return null;
  }
}

export default withRouter(Redirect);
